import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Modal, message as antMessage } from 'antd';
import { useTranslation } from 'react-i18next';
import useErrorMessage from '../../utils/ErrorMessage';
import useAuthContext from '../../contexts/AuthContext';

const ExemptionModal = ({
  openExemptionModal,
  setOpenExemptionModal,
  tempData,
  getContract
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { message } = useErrorMessage();
  const { dispatchAPI } = useAuthContext();

  const handleSubmit = async () => {
    try {
      const { check, key, modifiedValue, type } = tempData;
      const response = await dispatchAPI('PATCH', {
        url: `/contracts/value/${id}`,
        body: {
          value: modifiedValue,
          key,
          type,
          check
        }
      });
      if (response.status === 200) {
        antMessage.success(t('tickets.messages.success_newExemption'), 6);
      }
      setOpenExemptionModal(false);
      getContract();
    } catch (e) {
      message(e);
    }
  };

  return (
    <>
      <Modal
        title={t('tickets.modal.new_exemption_title')}
        centered
        open={openExemptionModal}
        closable={false}
        width={900}
        okText={t('tickets.modal.new_exemption_title')}
        cancelText={t('tickets.modal.rectify')}
        onOk={() => handleSubmit()}
        onCancel={() => setOpenExemptionModal(false)}
      >
        <div style={{ textAlign: 'center', fontWeight: 700 }}>
          {t('tickets.modal.new_exemption')}
        </div>
      </Modal>
    </>
  );
};

ExemptionModal.propTypes = {
  openExemptionModal: PropTypes.bool.isRequired,
  setOpenExemptionModal: PropTypes.func.isRequired,
  getContract: PropTypes.func.isRequired,
  tempData: PropTypes.shape({
    check: PropTypes.arrayOf(PropTypes.string),
    key: PropTypes.string,
    modifiedValue: PropTypes.number,
    type: PropTypes.string
  }).isRequired,
  contract: PropTypes.shape({
    amendment: PropTypes.arrayOf(PropTypes.string),
    previous_contract: PropTypes.string,
    customer: PropTypes.shape({
      email: PropTypes.string
    })
  }).isRequired,
  form: PropTypes.shape({
    validateFields: PropTypes.func
  }).isRequired
};

export default ExemptionModal;
